import CategoryIcon from "./CategoryIcon";

export default CategoryIcon;
